import { camelToKebab, hexToRgb, RGBAtoRGB } from '@/common';

export interface ValidatedConfig {
	apiKey: string;
	websiteId: string;
	buttonText: string | undefined;
}

export class PrecisePriceConfig {
	public readonly apiKey: string;

	public readonly ppSSOKey: string | undefined;

	public readonly websiteId: string;

	buttonText: string | undefined = '';

	styleVariables: StyleVariables = {};

	toRGB = ['primaryColor', 'successColor', 'errorColor'];

	constructor(data: PrecisePriceConfigObject) {
		this.apiKey = data.apiKey;

		this.ppSSOKey = data.ppSSOKey;

		this.buttonText = data.buttonText;

		try {
			this.websiteId = JSON.parse(atob(this.apiKey.split('.')[1])).WID;

			if (!this.websiteId) {
				throw new Error('Invalid API Key');
			}
		} catch (error) {
			throw new Error('Invalid API Key');
		}

		if (data.styleVariables && typeof data.styleVariables === 'object') {
			const { styleVariables } = data; // requires to let TS know that is definitely defined

			Object.keys(styleVariables).forEach(property => {
				if (typeof styleVariables[property] === 'string') {
					this.styleVariables[`--pp-${camelToKebab(property)}`] = styleVariables[property];
				}
			});

			this.toRGB.forEach(color => {
				const colorValue = styleVariables[color];

				if (colorValue) {
					let rgb = hexToRgb(colorValue);

					if (colorValue.indexOf('rgba') !== -1) {
						rgb = RGBAtoRGB(colorValue, 255, 255, 255);
					}

					if (!rgb) { return; }
					this.styleVariables[`--pp-${camelToKebab(color)}-rgb`] = `${rgb.r}, ${rgb.g}, ${rgb.b}`;
				}
			});
		}
	}

	public getConfig() {
		return {
			apiKey: this.apiKey,
			websiteId: this.websiteId,
			buttonText: this.buttonText,
		};
	}

	public getStyleVariables() {
		return this.styleVariables;
	}
}
